import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import PageTitle from "../PageTitle";
export default function NotFound() {

    return (
        <section className="page_404">
            <PageTitle label="Page Not Found" />
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="col-sm-10 col-sm-offset-1  text-center">
                            <div className="four_zero_four_bg" style={{
                                backgroundImage: `url("https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif")`,
                                backgroundPosition: "center",
                                height: "400px"
                            }}>
                                <h1 className="text-center">404</h1>
                            </div>
                            <div className="contant_box_404">
                                <h3 className="h2">
                                    Look like you're lost
                                </h3>
                                

                               
                                    <Button
                                      component={Link}
                                      to="/"
                                      variant="primary"
                                      style={{background: "#37334f", color: "white"}}
                                      className="custom-btn link_404"
                                      color={"primary"}
                                    >
                                      Go to Home
                                    </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}